import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    dateFormat: { type: String, default: "DD-MM-YYYY h:mma" },
    outputFormat: { type: String, default: "YYYY-MM-DD HH:mm:ss" },
    startInput: { type: String, default: "start_at" },
    endInput: { type: String, default: "end_at" }
  }

  connect() {
    const startInput = this.element.parentElement.querySelector(`input[name$="[${this.startInputValue}]"]`)
    const endInput = this.element.parentElement.querySelector(`input[name$="[${this.endInputValue}]"]`)
    const outputFormat = this.outputFormatValue

    $(this.element).daterangepicker({
      opens: 'right',
      timePicker: true,
      applyButtonClasses: "bg-purple-dark text-white rounded-md",
      cancelButtonClasses: "text-purple-dark",
      locale: {
        format: this.dateFormatValue
      }
    }, (start, end) => {
      if (startInput) {
        startInput.value = start.format(outputFormat)
        startInput.dispatchEvent(new Event('change', { bubbles: true }))
      }
      if (endInput) {
        endInput.value = end.format(outputFormat)
        endInput.dispatchEvent(new Event('change', { bubbles: true }))
      }
    });
  }
}
